/**
 * Code Block Component
 *
 * Renders code blocks with syntax highlighting and a copy button.
 * Used within markdown rendering for AI responses.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
type CodeBlockProps = {
  children: string;
  className?: string;
  inline?: boolean;
};
const CodeBlock: React.FC<CodeBlockProps> = t0 => {
  const $ = _c(22);
  const {
    children,
    className,
    inline
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== className) {
    t1 = className?.replace(/language-/, "") || "text";
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const language = t1;
  let t2;
  if ($[2] !== children) {
    t2 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(children);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (t3) {
        const err = t3;
        console.error("Failed to copy code:", err);
      }
    };
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleCopy = t2;
  if (inline) {
    let t3;
    if ($[4] !== children) {
      t3 = <code className="rounded bg-slate-800 px-1.5 py-0.5 text-xs font-mono text-purple-300">{children}</code>;
      $[4] = children;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== language) {
    t3 = <span className="text-xs font-medium text-slate-400 uppercase tracking-wide">{language}</span>;
    $[6] = language;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = copied ? "Copied!" : "Copy code";
  let t5;
  if ($[8] !== copied) {
    t5 = copied ? <><svg className="h-4 w-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg><span className="text-green-400">Copied!</span></> : <><svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg><span>Copy</span></>;
    $[8] = copied;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleCopy || $[11] !== t4 || $[12] !== t5) {
    t6 = <button onClick={handleCopy} className="flex items-center gap-1.5 rounded-md px-2 py-1 text-xs text-slate-300 hover:bg-slate-800 transition-colors" title={t4}>{t5}</button>;
    $[10] = handleCopy;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex items-center justify-between border-b border-slate-700 bg-slate-900/50 px-4 py-2">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children) {
    t8 = <div className="overflow-x-auto"><pre className="p-4 text-sm leading-relaxed"><code className="font-mono text-slate-200">{children}</code></pre></div>;
    $[17] = children;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="group relative my-3 rounded-lg border border-slate-700 bg-slate-950">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default CodeBlock;